import { useEffect, useState } from "react"
import { URL_BACKEND } from "../../api/url"

export const useMaterias = (fk_carrera = "todos") => {

    // variables
    const [materias, setMaterias] = useState([])
    
    // funciones
    const traerMaterias = () => {

        let d = new FormData()
        d.append('funcion', 'traerMaterias')
        d.append('fk_carrera', fk_carrera)


        fetch( URL_BACKEND, {
            body: d,
            method: 'post'
        })
        .then( res => res.json() )
        .then( setMaterias )
        .catch( () => alert("Error al traer materias") )

    }


    // useEffects
    useEffect(() => {
        traerMaterias()
        // eslint-disable-next-line
    }, [])
    

    return {
        materias
    }
}

